<template>
  <migration-request />
</template>

<script>
import MigrationRequest from '@/components/Support/Migration'

export default {
  name: 'MigrationView',
  components: {
    MigrationRequest
  }
}
</script>
